import React from 'react'

function Education() {
    return (
        <div className="main1">
       

        <div className="intro-wrapper1">
            <div className="nav-wrapper">
                <div className="dots-wrapper">
                     <div id="dot-1" className="browser-dot"></div>
                      <div id="dot-2" className="browser-dot"></div>
                        <div id="dot-3" className="browser-dot"></div>
                </div>
                      <div className="dots-wrapper">
                     <div id="dot-1" className="browser-dot"></div>
                      <div id="dot-2" className="browser-dot"></div>
                        <div id="dot-3" className="browser-dot"></div>
                </div>
                   <div className="dots-wrapper">
                     <div id="dot-1" className="browser-dot"></div>
                        <div id="dot-2" className="browser-dot"></div>
                        <div id="dot-3" className="browser-dot"></div>
                      </div>
                   <ul className="navigation">
                       <li><a href="/" ></a></li>
                      <div className="dots-wrapper">
                     <div id="dot-1" className="browser-dot"></div>
                        <div id="dot-2" className="browser-dot"></div>
                        <div id="dot-3" className="browser-dot"></div>
                      </div>
                  
                 
                </ul>
             </div>
                <div className="brand">
                 <h4>Educations:</h4>
                 </div>
                <div className="columnthree">

                    <div id="preview1">
                         <div  id="corner-tl" className="corner"></div>
                         <div  id="corner-tr" className="corner"></div>
                             <div class="image">
                            
                             <img src="" alt=""/>
                              </div> 
                          {/*    Object begin */}
                            <div class="image">
                                  <img src="https://th.bing.com/th/id/OIP.htBUXWjTJHZNPEblBPgnLgAAAA?w=204&h=106&c=7&o=5&dpr=1.75&pid=1.7" alt=""/>
                             </div>
                             <h4>Vaughn College of Aeronautics and Technology (Flushing, New York 2005-)</h4><br></br>
                            
                              <h5>Degree:</h5><br></br>
                              <p>Bachelor of Science in Airframe and Powerplant Engineering.</p>
                            {/*  Object End */}
                         <div className="dots-wrapper1">
                             <div id="dot-1" className="browser-dot1"></div>
                                 <div id="dot-2" className="browser-dot1"></div>
                                <div id="dot-3" className="browser-dot1"></div>
                           </div>
                         <div  id="corner-br" className="corner"></div>
                          <div  id="corner-bl" className="corner"></div>
                       </div>


                        {/*   preview box-2 */}
                          <div id="preview1">
                         <div  id="corner-tl" className="corner"></div>
                         <div  id="corner-tr" className="corner"></div>
                           <div class="image">
                             <img src="https://th.bing.com/th/id/OIP.Nwkz6k5PwdAkbhOF-qZLzAF2Cm?w=281&h=134&c=7&o=5&dpr=1.75&pid=1.7"/>
                              </div> 
                              <h4>Computer career Center(New York -2000-2002) </h4><br></br>
                               <h5>Degree:</h5><br></br>
                              <p>Microsoft Certified Systems Engineer</p>
                               
                         <div className="dots-wrapper1">
                             <div id="dot-1" className="browser-dot1"></div>
                                 <div id="dot-2" className="browser-dot1"></div>
                                <div id="dot-3" className="browser-dot1"></div>
                           </div>
                         <div  id="corner-br" className="corner"></div>
                          <div  id="corner-bl" className="corner"></div>
                       </div>


                       <div id="preview1">
                         <div  id="corner-tl" className="corner"></div>
                         <div  id="corner-tr" className="corner"></div>
                             <div class="image">
                            
                             <img src="" alt=""/>
                              </div> 
                          {/*    Object begin */}
                            <div class="image">
                                  <img src="https://th.bing.com/th/id/OIP.Pihp_dWebsA_CaZpNUemiAHaEc?w=268&h=180&c=7&o=5&dpr=1.75&pid=1.7"/>
                             </div>
                            <h4>Xincon Technology School (NYC-New York 2003-2005)</h4><br></br>
                                  <h5>Degree:</h5><br></br>
                              <p>CIW Foundation </p>
                            {/*  Object End */}
                         <div className="dots-wrapper1">
                             <div id="dot-1" className="browser-dot1"></div>
                                 <div id="dot-2" className="browser-dot1"></div>
                                <div id="dot-3" className="browser-dot1"></div>
                           </div>
                         <div  id="corner-br" className="corner"></div>
                          <div  id="corner-bl" className="corner"></div>
                       </div>
                        {/*   preview box-2 */}

                     
                       {/*   preview box-1 */}
                       <div id="preview1">
                         <div  id="corner-tl" className="corner"></div>
                         <div  id="corner-tr" className="corner"></div>
                             <div class="image">
                            
                             <img src="" alt=""/>
                              </div> 
                          {/*    Object begin */}
                            <div class="image">
                                  <img src="https://th.bing.com/th/id/OIP.kZxb7FwHd9TkcJjJlAiGhwHaHa?w=149&h=180&c=7&o=5&dpr=1.75&pid=1.7"/>
                              </div>
                             <h4>American Software Testing Qualifications Board</h4><br></br>
                              <h5>ASTQB certified:</h5><br></br>
                              <p>CTFL and CTFL-AT</p>
                            {/*  Object End */}
                         <div className="dots-wrapper1">
                             <div id="dot-1" className="browser-dot1"></div>
                                 <div id="dot-2" className="browser-dot1"></div>
                                <div id="dot-3" className="browser-dot1"></div>
                           </div>
                         <div  id="corner-br" className="corner"></div>
                          <div  id="corner-bl" className="corner"></div>
                       </div>
                        {/*   preview box-2 */}

                
                 
              
                   
                 
               </div>  

         
       
            
          
        </div>
                
        </div>
    )
}

export default Education
